var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Form, Field } from 'react-redux-form';
import { Icon } from "../../UI";

export class TocForm extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  indentButton(direction, tocElement) {
    const { indent } = this.props;
    const onClick = indent.bind(
    null,
    tocElement,
    tocElement.indentation + (direction === 'more' ? 1 : -1));

    return /*#__PURE__*/(
      _jsx("button", { type: "button", onClick: onClick, className: `toc-indent-${direction} btn btn-default` }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: direction === 'more' ? 'arrow-right' : 'arrow-left', directionAware: true })));


  }

  submit(toc) {
    this.props.onSubmit(toc, this.props.file._id);
  }

  render() {
    const { toc, model, removeEntry } = this.props;
    return /*#__PURE__*/(
      _jsx(Form, { className: "toc", id: "tocForm", model: model, onSubmit: this.submit }, void 0,
      toc.map((tocElement, index) => /*#__PURE__*/
      _jsx("div", { className: `toc-indent-${tocElement.indentation}` }, index, /*#__PURE__*/
      _jsx("div", { className: "toc-edit" }, void 0,
      this.indentButton('less', tocElement),
      this.indentButton('more', tocElement), /*#__PURE__*/
      _jsx(Field, { model: `${model}[${index}].label` }, void 0, /*#__PURE__*/
      _jsx("input", { className: "form-control" })), /*#__PURE__*/

      _jsx("button", {
        type: "button",
        onClick: removeEntry.bind(this, tocElement),
        className: "btn btn-danger" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "trash-alt" })))))));






  }
}

TocForm.defaultProps = {
  toc: [],
  removeEntry: () => {},
  indent: () => {},
  onSubmit: () => {}
};










export default TocForm;